function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: -0.265,
  x2: 0.628,
  y2: 1.258,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#003044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00c4ff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_121",
  "data-name": "Group 121",
  transform: "translate(-2483.404 -1101.939)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M2561.793,1101.939h-64.612a1.185,1.185,0,0,0-1.186,1.186v11.583h48.95a1.849,1.849,0,0,1,1.849,1.85v52.364h15a1.187,1.187,0,0,0,1.186-1.186v-64.612A1.186,1.186,0,0,0,2561.793,1101.939Z",
  transform: "translate(9.155)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_3",
  "data-name": "Subtraction 3",
  d: "M304.174,2148.551a1.071,1.071,0,0,1-1.085-1.079V2133.45h-16a1.188,1.188,0,0,1-1.187-1.186v-64.612a1.188,1.188,0,0,1,1.187-1.186H351.7a1.187,1.187,0,0,1,1.186,1.186v64.612a1.187,1.187,0,0,1-1.186,1.186H317.63l-12.648,14.723A1.053,1.053,0,0,1,304.174,2148.551Zm14.563-69.423a.631.631,0,0,0-.572.37l-10.975,23.388a.654.654,0,0,0-.06.269.634.634,0,0,0,.634.634h7.977a.635.635,0,0,1,.6.842l-6.22,18.045c-.175.51-.1.831.209.956a.729.729,0,0,0,.267.056.828.828,0,0,0,.625-.42L332.35,2095.7a.623.623,0,0,0,.13-.374.636.636,0,0,0-.624-.644h-8.032a.634.634,0,0,1-.542-.959l8.138-13.637a.634.634,0,0,0-.542-.958Z",
  transform: "translate(2198 -946.697)",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1,
  fill: "url(#linear-gradient)"
}));

var SvgTopics = function SvgTopics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88.73,
    height: 100.415,
    viewBox: "0 0 88.73 100.415",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Topics.3453da51.svg";
export { ForwardRef as ReactComponent };